<template>
  <template v-for="group in groups" :key="group.category">
    <section
      v-if="group.services.length"
      :id="`uslugi-${group.category}`"
      class="scroll-mt-[48px] flex min-w-0 flex-col gap-3 rounded-xl bg-white p-4 shadow-[0px_6px_7.5px_rgba(16,24,40,0.08)] lg:scroll-mt-[64px] lg:p-6"
    >
      <h2 class="text-sm font-semibold uppercase tracking-[1px] text-neutral-500">
        {{ group.label }}
      </h2>

      <ul class="flex min-w-0 flex-col">
        <li
          v-for="service in group.services"
          :key="service.slug || service.id"
          class="flex min-w-0 flex-wrap items-center justify-between gap-3 border-b border-neutral-200 py-4"
        >
          <div class="flex min-w-0 flex-1 flex-col gap-1">
            <p class="min-w-0 break-words whitespace-pre-line text-base leading-6 text-neutral-900">
              {{ service.name }}
            </p>
            <p
              v-if="formatMeta(service)"
              class="text-sm font-semibold leading-4 text-green-600"
            >
              {{ formatMeta(service) }}
            </p>
          </div>

          <Link
            :href="serviceHref(service)"
            class="btn-nav flex shrink-0 items-center justify-center gap-2 text-[14px] font-normal leading-4 no-underline"
          >
            {{ $t('common.view') }}
            <svg
              class="size-5 shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
            </svg>
          </Link>
        </li>
      </ul>
    </section>
  </template>
</template>

<script>
import { Link } from '@inertiajs/vue3';
import { formatServiceMeta } from '@/utils/serviceMeta';

// Fixed display order for the three service categories. Section headings are
// resolved from the shared translations (`services.sections.*`).
const CATEGORY_ORDER = ['konsultacja_medyczna', 'zabieg', 'badanie'];

export default {
  name: 'ServiceCategoryList',
  components: { Link },
  props: {
    services: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    groups() {
      return CATEGORY_ORDER.map((category) => ({
        category,
        label: this.$t(`services.sections.${category}`),
        services: this.services.filter((service) => service.category === category),
      }));
    },
  },
  methods: {
    formatMeta(service) {
      return formatServiceMeta(service);
    },
    serviceHref(service) {
      return this.$routes.service(service.slug);
    },
  },
};
</script>
